/** localStorage keys（仅主应用入口使用） */
export const STORAGE_ADMIN_COLOR = 'adminColorPreset';
export const STORAGE_ADMIN_THEME = 'adminThemeMode';

/** 与 admin-appearance.css 中 data-admin-color 一致 */
export const ADMIN_COLOR_PRESET_ORDER = [
    'default',
    'fog-blue-gray',
    'mist-teal',
    'olive-apricot',
    'cool-gray-beige',
    'gray-pink-mist',
    'blue-orange-muted',
];

export function normalizeAdminColorPreset(raw) {
    if (!raw || typeof raw !== 'string') {
        return 'default';
    }
    return ADMIN_COLOR_PRESET_ORDER.includes(raw) ? raw : 'default';
}

export function normalizeAdminThemeMode(raw) {
    if (raw === 'light' || raw === 'dark' || raw === 'system') {
        return raw;
    }
    return 'system';
}
